import React from 'react';

import { Grid } from '@gogame/components';
import { withArrayFormField, FormFieldGroup } from '@gogame/form';

import { Campaign } from './Campaign';

const EMPTY_CAMPAIGNS = [];
const EMPTY_PLATFORMS = [];

export const MultiCampaigns = withArrayFormField()(({
  name,
  value = EMPTY_CAMPAIGNS,
  platforms = EMPTY_PLATFORMS,
}) => {
  return (
    <Grid container spacing={3}>
      {value.map((_, i) => {
        const platformName = value.length > 1 ? platforms?.[i]?.name : '';
        return (
          <Grid item xs={12} key={i}>
            <FormFieldGroup name={`${name}[${i}]`}>
              <Campaign platformName={platformName} />
            </FormFieldGroup>
          </Grid>
        );
      })}
    </Grid>
  );
});
